import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pairs',
})
export class PairsPipe implements PipeTransform {
  transform(array, groupNumber = 0) {
    let groupStart = Math.ceil(array.length / 3) * groupNumber;
    let groupEnd = groupStart + Math.ceil(array.length / 3);
    return array.slice(groupStart, groupEnd);
  }
}
